import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { TagForm } from '../../forms/tag.form';
import { Tag } from '../../models/tag.model';

@Component({
standalone: false,
  selector: 'app-tag-list-edit',
  styleUrls: ['./tag-list-edit.component.scss'],
  templateUrl: './tag-list-edit.component.html',
})
export class TagListEditComponent {
  @Input() public tag: Tag;
  @Input() public editForm: TagForm;
  @Input() public save: (tag: Tag, tagName: string) => Observable<any>;
  @Input() public delete: (tag: Tag) => Observable<any>;
  @Input() public cancel: () => void;

  constructor() {
  }

  public onSave = () => this.save(this.tag, this.editForm.tagName.value);

  public onDelete = () => this.delete(this.tag);
}
